import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="agent-assignment"
export default class extends Controller {
  static targets = [ "link", "fields" ]
  connect() {
  }

  showFields() {
    this.linkTarget.classList.add("hidden");
    this.fieldsTarget.classList.remove("hidden");

    const firstField = this.fieldsTarget.querySelector("input");
    if (firstField) { firstField.focus(); }
  }
}
